import { Component, OnInit } from '@angular/core';
import { AuthService } from '@/shared/services';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'profile-page-main-content',
  templateUrl: './profile-page-main-content.component.html',
  styleUrls: ['./profile-page-main-content.component.css'],
  standalone: false,
})
export class ProfilePageMainContentComponent implements OnInit {
  public firstName!: string;
  public lastName!: string;
  public userRole!: string | undefined;
  public env = environment;

  constructor(public authService: AuthService) {
    // Getting user's name
    const name = authService.getUserName();
    this.firstName = name.first_name;
    this.lastName = name.last_name;
  }

  ngOnInit(): void {
    this.userRole = this.authService.getRoleTitle();
  }

  url: any; //Angular 11, for stricter type
  msg = '';

  //selectFile(event) { //Angular 8
  selectFile(event: any) {
    //Angular 11, for stricter type
    if (!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg = 'You must select an image';
      return;
    }

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.msg = 'Only images are supported';
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);

    reader.onload = (_event) => {
      this.msg = '';
      this.url = reader.result;
    };
  }
}
